import { render, staticRenderFns } from "./VRadio.vue?vue&type=template&id=22b911c2&"
import script from "./VRadio.vue?vue&type=script&lang=js&"
export * from "./VRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports